<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
      <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
      <!--<h1 class="mui-title">已检一览</h1>-->
    <!--</header>-->
    <div class="mui-content pd-8">
      <div class="title-name">
        <span class="">已检一览</span>
      </div>
      <!--基础信息-->
      <div class="sampling-first" style="border-bottom: 1px dashed #CCCCCC;margin-top: 15px;">
        <!--第一行-->
        <div class="sampling-first-title">
          <h4 style="padding-left: 0px;">基础信息</h4>
        </div>
        <!--第二行内容-->
        <div class="sampling-first-content">
          <!--第1行-->
          <div style="font-size: 14px;padding-top: 0px;padding-bottom: 3px;">
            <div class="sampling-first-content-left">
              <span>外注订单:</span>
            </div>
            <div class="flex-9">
              <span>{{ddh}}</span>
            </div>
          </div>
          <div style="font-size: 14px;padding-top: 0px;padding-bottom: 3px;">
            <div class="sampling-first-content-left">
              <span>物料:</span>
            </div>
            <div class="flex-9" style="white-space: nowrap;">
              <span>{{scxtwph}} {{scxtwpmc}}</span>
            </div>
          </div>
          <div style="font-size: 14px;padding-top: 0px;padding-bottom: 3px;">
            <div class="sampling-first-content-left">
              <span>出库单号:</span>
            </div>
            <div class="flex-9">
              <span>{{shipmentno}}</span>
            </div>
          </div>
          <!--第2行-->
          <div style="font-size: 14px;padding-top: 0px;padding-bottom: 3px;">
            <div class="sampling-first-content-left">
              <span>指示数量:</span>
            </div>
            <div class="flex-9">
              <span>{{zssl}}{{dw}}</span>
            </div>
          </div>
<!--           <div style="display: flex;">
            <div class="flex-1" style="font-size: 14px;display: flex;">
              <div class="sampling-first-content-left flex-3">
                <span>指示数量:</span>
              </div>
              <div class="flex-3">
                <span>{{zssl}}{{dw}}</span>
              </div>
            </div>
            <div class="flex-1" style="font-size: 14px;display: flex;">
              <div class="sampling-first-content-left flex-3">
                <span>物料:</span>
              </div>
              <div class="flex-5" style="white-space: nowrap;">
                <span>{{scxtwph}} {{scxtwpmc}}</span>
              </div>
            </div>
          </div> -->
          <!--第2行-->
          <div style="display: flex;padding-top: 0px;padding-bottom: 3px;">
            <div style="display: flex;font-size: 17px;color: red;vertical-align: middle;line-height: 40px;" class="flex-3">
              <div class="sampling-first-content-left" style="flex: none;min-width:20px;text-align: left;line-height: 40px;">
                <span class="flex-red" style="font-size: 18px;">抽检率要求:</span>
              </div>
              <div class="flex-2">
                <span class="flex-red" style="font-size: 18px;">{{randomcheckrate}}%</span>
              </div>
            </div>
            <div class="flex-1" style="font-size: 14px;display: flex;vertical-align: middle;">
                <button type="button" class="mui-btn mui-btn-primary btn-blue" style="min-width: 80px;" @tap="finish">抽检完成</button>
            </div>
          </div>
        </div>
        <!--<div class="sampling-first-content" style="font-size: 14px;">-->
          <!--<div class="sampling-first-content" style="display: flex;">-->
            <!--&lt;!&ndash;第1行&ndash;&gt;-->
            <!--<div style="flex: 3;display: flex;">-->
              <!--<span>外注订单：</span>-->
              <!--<span>{{ddh}}</span>-->
            <!--</div>-->
            <!--&lt;!&ndash;第2行&ndash;&gt;-->
            <!--<div style="flex: 2;display: flex;">-->
              <!--<span>指示数量：</span>-->
              <!--<span>{{zssl}}{{dw}}</span>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div style="padding: 0 10px;">-->
            <!--&lt;!&ndash;第1行&ndash;&gt;-->
            <!--<div class="left">-->
              <!--<div class="leftcss">-->
                <!--<span>出库单号：</span>-->
                <!--<span>{{shipmentno}}</span>-->
              <!--</div>-->
              <!--<div class="leftcss">-->
                <!--<span>物料：</span>-->
                <!--<span>{{scxtwph}} {{scxtwpmc}}</span>-->
              <!--</div>-->
            <!--</div>-->
            <!--&lt;!&ndash;第2行&ndash;&gt;-->
            <!--<div class="right">-->
              <!--<div style="height:100%;margin-top:6px;">-->
                <!--<button type="button" class="mui-btn mui-btn-primary" style="width: 80px;" @tap="finish">抽检完成</button>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="sampling-first-content" style="display: flex;">-->
            <!--&lt;!&ndash;第1行&ndash;&gt;-->
            <!--<div style="flex: 3;display: flex;font-size: 17px;" class="flex-red">-->
              <!--<span>抽检率要求：</span>-->
              <!--<span>{{randomcheckrate}}%</span>-->
            <!--</div>-->
          <!--</div>-->
        <!--</div>-->
      </div>
      <div class="sampling-first" style="margin-top: 15px;border-bottom:0px;">
        <!--第一行-->
        <div class="sampling-first-title">
          <h4 style="position: relative;text-align: left;padding-left: 0px;">已检明细
              <span style="position: absolute;right: 10px;font-size: 13px;">抽检数量：{{cjsl}}{{dw}}({{cjjs}}卷) {{sjcjl}}%</span>
            </h4>
            <h4 style="position: relative;text-align: left;padding-left: 0px;height: 20px;padding-top: 0px;">
              <span style="position: absolute;right: 10px;font-size: 13px;">抽检率（卷）：{{sjcjl_j}}%（匹）：{{sjcjl_p}}%</span>
            </h4>
        </div>
        <div class="sampling-first-content">
          <ul class="mui-table-view">
            <li class="mui-table-view-cell flex-content" style="display: block;" v-for="(item,i) in infoLst">
              <div class="mui-slider-right mui-disabled">
                <a class="mui-btn mui-btn-yellow" @tap="detail(item, $event)">详情</a>
                <!-- <a class="mui-btn mui-btn-red" v-if="(item.statusflg=='0')&&(statusflg!='3') && (!item.zdflg)" @tap="del(item.tsdrollno)">删除</a> -->
              </div>
              <div class="mui-slider-handle">
                <div class="mui-table-cell">
                  <div class="flex-box"  style="display: flex;flex-wrap: wrap;">
                    <div class="flex-container">
                      <div class="flex-content-container" style="display: flex;">
                        <div class="flex-content-span flex-1" style="width:21px;text-align:center;font-weight:bold;"><span>{{(i+1)}}</span></div>
                        <div class="flex-content-label" style="padding-right: 0px;min-width: 35px;">外注卷号:</div>
                        <div class="flex-content-span flex-1"><span>{{item.wzrollno}}</span></div>
                      </div>
                    </div>
                    <div class="flex-container" style="margin-left: 5px;margin-right: 10px;">
                      <div class="flex-content-container flex-2" style="min-width:80px;display: flex;">
                        <div class="flex-content-label" style="min-width: 35px;padding-left:6px;">数量:</div>
                        <div class="flex-content-span flex-1"><span>{{item.sl}}{{dw}}</span></div>
                        <!--<span style="margin-left: 10px;" class="flex-gray">{{item.grade=='B'?'悬念反':item.grade}}</span>-->
                      </div>
                      <!--<div class="flex-content-container flex-1">-->
                        <!--<span :class="[item.cjgrade=='B'?'flex-red':'flex-green']">{{item.cjgrade?(item.cjgrade=='B'?'悬念反':('抽（'+item.cjgrade+'）')):''}}</span>-->
                      <!--</div>-->
                    </div>
                    <div  class="flex-container" style="vertical-align: middle;display: table-cell;">
                      <span style="margin-left: 10px;" class="flex-gray">{{item.grade=='B'?'悬念反':item.grade}}</span>
                      <span :class="[item.cjgrade=='B'?'flex-red':'flex-green']">{{item.cjgrade?(item.cjgrade=='B'?'悬念反':('抽（'+item.cjgrade+'）')):''}}</span>

                    </div>
                    <!--<div class="flex-container">-->
                      <!--<div class="flex-content-container flex-4">-->
                        <!--<span>TSD卷号:</span><span>{{item.tsdrollno}}</span>-->
                        <!--<div class="flex-content-span flex-7"></div>-->
                      <!--</div>-->
                      <!--<div class="flex-content-container flex-1"></div>-->
                    <!--</div>-->
                    <!--<div class="flex-container">-->
                      <!--<div class="flex-content-container flex-3">-->
                        <!--<span>数量:</span><span>{{item.sl}}{{dw}}</span><span style="margin-left: 10px;" class="flex-gray">{{item.grade=='B'?'悬念反':item.grade}}</span>-->
                      <!--</div>-->
                      <!--<div class="flex-content-container flex-1">-->
                        <!--<span :class="[item.cjgrade=='B'?'flex-red':'flex-green']">{{item.cjgrade?(item.cjgrade=='B'?'悬念反':('抽（'+item.cjgrade+'）')):''}}</span>-->
                      <!--</div>-->
                    <!--</div>-->
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "qualityListCJ",
  data() {
    return {
      ddh: "",
      wph: "",
      shipmentno: "",
      scxtwph: "",
      scxtwpmc: "",
      zssl: "",
      dw: "",
      randomcheckrate: "",
      cjsl: "",
      infoLst: [],
      ksbh: "",
      sl: "", // 指示数量
      yjsl: "", // 已检数量
      statusflg: "",
      zdsl:"",// 指定数量
      cjjs: "",
      sjcjl: 0,
      sjcjl_j: 0,
      zdps: 0,
      cjps: 0,
      zdjs: 0,
      sjcjl_p: 0
    }
  },
  created() {},
  activated() {
    var v = this;
    const para = getJsonPara(v.$route);
    if (para) {
      v.ddh = para.ddh;
      v.wph = para.wph;
      v.shipmentno = para.shipmentno;
      v.ksbh = para.ksbh;
      v.getListbyzj();
    }
  },
  methods: {
    getListbyzj() {
      var v = this;
      v.nyy.doPost("/Quality/getListbyzj", {
          ddh: v.ddh,
          wph: v.wph,
          shipmentno: v.shipmentno
        },
        function(result) {
          if (result.status) {
            var info = result.data.info;
            v.scxtwph = info.scxtwph;
            v.scxtwpmc = info.scxtwpmc;
            v.zssl = info.zssl;
            v.dw = info.dw;
            v.randomcheckrate = info.randomcheckrate;
            v.yjsl = info.yjsl;
            v.cjsl = info.cjsl;
            v.sl = info.sl;
            v.zdsl = info.zdsl;
            v.infoLst = info.list ? JSON.parse(info.list) : [];
            v.statusflg = info.statusflg;
            v.cjjs = info.cjjs;
            // 实际抽检数量/指定明细总数量
            v.sjcjl = (v.zdsl != 0) ? (parseFloat(v.cjsl)*100/parseFloat(v.zdsl)).toFixed(1) :0;
            v.zdjs = info.zdjs;
            v.sjcjl_j = (v.zdjs != 0) ? (parseFloat(v.cjjs)*100/parseFloat(v.zdjs)).toFixed(1) :0; 
            v.zdps = info.zdps;
            v.cjps = info.cjps;
            v.sjcjl_p = (v.zdps != 0 )? (parseFloat(v.cjps)*100/parseFloat(v.zdps)).toFixed(1) :0;
          }
        }
      );
    },
    del(tsdrollno) {
      var v = this;
      mui.confirm('确定删除TSD卷号' + tsdrollno + '质检记录？', '提示', ['否', '是'], function(e) {
        if (e.index == 1) {
          v.nyy.doPost("/Quality/del", {
              ddh: v.ddh,
              wph: v.wph,
              tsdrollno: tsdrollno
            },
            function(result) {
              if (result.status) {
                v.getListbyzj();
              } else {
                mui.toast(result.message);
              }
            }
          );
        }
      });
    },
    detail(item,e) {
      var v = this;
      var li =$(e.target).parents('li');
      if(li.length<=0)return;
      li = li[0];

      setTimeout(function() {
        mui.swipeoutClose(li);
      }, 0);
      v.$router.push({ "name": "qualityDetail", params: jsonPara({ "ksbh": v.ksbh, "ddh": v.ddh, "wph": v.wph, "tsdrollno": item.tsdrollno,"shipmentno": v.shipmentno,"idx": item.idx,"readonly": (v.statusflg=='3'?true:false) ,"iscj":true}) });
    },
    finish() {
      var v = this;
      // 合格率校验 抽检数量/已指定数量
      var hgl = parseFloat(((parseFloat(v.cjsl) / parseFloat(v.zdsl)) * 100).toFixed(2));
      if ((parseFloat(v.randomcheckrate) > hgl) && (parseFloat(v.randomcheckrate)>parseFloat(v.sjcjl_j)) && (parseFloat(v.randomcheckrate)>parseFloat(v.sjcjl_p))) {
        mui.toast("抽检率未达到要求");
        return;
      }
      // 不合格数量
      var bhgsl = 0;
      // 含有悬念反
      var xnf = 0;
      v.infoLst.forEach(function(element, index) {
        if (element.cjgrade == 'C') {
          bhgsl++;
        }
        if (element.cjgrade == 'B') {
          xnf++;
        }
      });
      // 存在C级品
      if (bhgsl > 0) {
        // 状态更新为指示
        mui.alert("抽检明细存在C反，请联系外注厂家变更","提示",function(){
          v.update({
            shipmentno: v.shipmentno,
            statusflg: "1",
            approveflg: "3"
          },function(){
            v.$router.go(-1);
          });
        });
        return;
      }
      var postMap = {};
      // 不含C级，则该出库单状态更新为“抽检完成” 存在悬念反，则审核状态为“待审核”
      var xnfflg = false;
      if (xnf > 0) {
        postMap = {
          shipmentno: v.shipmentno,
          statusflg: "3",
          approveflg: "0"
        };
        xnfflg = true;
      } else {
        // 否则更新为无需审核
        postMap = {
          shipmentno: v.shipmentno,
          statusflg: "3",
          approveflg: "9"
        };
      }
      v.update(postMap,function(){
        if(xnfflg){
          v.notifyMsg({
            "content": "出库单" + v.shipmentno + "等待审核"
          })
        }else{
          v.$router.go(-1);
        }
      });
    },
    update(postMap,callback){
      var v = this;
      v.nyy.doPost("/Quality/update", postMap,
        function(result) {
          if (result.status) {
            if(callback) callback();
          } else {
            mui.toast(result.message);
          }
        }
      );
    },
    notifyMsg(postMap){
      var v = this;
      v.nyy.doPost("/Notify/notifyMsg", postMap,
        function(result) {
          if (result.status) {
            v.$router.go(-1);
          } else {
            mui.toast(result.message);
          }
        }
      );
    }
  }
}
</script>
<style scoped>
@import "../../static/css/sampling.css";
@import "../../static/css/samplinghistory.css";
.left {
  width: -moz-calc(100% - 100px);
  width: -webkit-calc(100% - 100px);
  width: calc(100% - 100px);
  float: left;
}
.right {
  float: left;
}
.leftcss {
  width: 100%;
  text-align: left;
  float: left;
  padding: 6px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/qualityListCJ.vue